<template>
  <div class="footer">
    <div class="footer-content">
      <div class="menu-list flex-top">
        <div class="menu-item "
             v-for="(item,index) in menuList"
             :key="index">
          <router-link :to='item.routerUrl'>
            <div class="item footer-text"
                 :class="$route.path==item.routerUrl?'active':'text-desc'">
              {{item.name}}
            </div>
          </router-link>
        </div>
      </div>
      <div class="footer-text"
           style="padding-top:20px;white-space:pre-wrap">{{copyright}}</div>
    </div>
  </div>

</template>

<script>
import { getconfig } from '@/api/website'
import info from '../util/info'
export default {

  data () {
    return {
      menuList: info.menuList,
      copyright: ''
    }
  },
  created () {
    this.initConfig()
  },
  methods: {
    initConfig () {
      getconfig().then(res => {
        if (res.code === 0) {
          let arr = res.data
          let copyright = ''
          let beian = ''
          arr.map(item => {
            if (item.name === 'copyright') {
              copyright = item.value
            }
            if (item.name === 'beian') {
              beian = item.value
            }
          })

          this.copyright = copyright + '  ' + beian
        }
      })
    }
  }
}
</script>

<style scoped>
.item {
  width: 150px;
}
.footer-content {
  padding: 40px;
  text-align: center;
}
.footer {
  width: 100%;
  text-align: center;
  height: 145px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  opacity: 1;
  border-top: 1px solid #484747;
  z-index: 99;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/tabfooter.vue